import { useEffect, useState } from 'react';
import { useLoading } from 'hooks/3catinfo/useLoading';
import SkeletonLoadingPages from './SkeletonLoadingPages/SkeletonLoadingPages';
import LoadingSpinner from 'components/3catinfo/LoadingSpinner';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './loading.module.scss';

export default function Loading() {
    const { activeLoading, skeletonLoading } = useLoading();
    const [loadingVisible, setLoadingVisible] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    const [skeletonPage, setSkeletonPage] = useState(false);
    const timeShowLoading = 800;
    const showSkeleton = true;

    useEffect(() => {
        if (activeLoading.active) {
            setTimeoutId(null);
            setTimeoutId(
                setTimeout(() => {
                    setLoadingVisible(activeLoading.active);
                }, timeShowLoading)
            );
        } else {
            clearTimeout(timeoutId);
            setLoadingVisible(activeLoading.active);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeLoading]);

    useEffect(() => {
        if (showSkeleton) {
            if (skeletonLoading && !__isEmpty(skeletonLoading)) {
                setSkeletonPage(<SkeletonLoadingPages {...skeletonLoading} />);
            } else {
                setSkeletonPage(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skeletonLoading]);

    useEffect(() => {
        if (skeletonPage) {
            setTimeout(() => {
                if (document.querySelector('[data-content="skeleton-loading-page"]')) {
                    window.scrollTo({ top: 0, left: 0 });
                }
            }, 10);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skeletonPage]);

    const stylesLoading = clsx({
        [styles.loadingBg]: true,
        [activeLoading.style]: !!activeLoading.style
    });

    return (
        <>
            {skeletonPage && <>{skeletonPage}</>}
            {loadingVisible && 
                <div className={styles.loadingContainer}>
                    <div className={stylesLoading}>
                        <div className={styles.loadingCenter}>
                            <LoadingSpinner message={activeLoading.msg} />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
